import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, unref as _unref, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-8fa62082"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "result-block" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = {
  key: 0,
  class: "result-block__title-box"
}
const _hoisted_4 = { class: "result-block__title" }
const _hoisted_5 = {
  key: 2,
  class: "result-block__sort"
}
const _hoisted_6 = { class: "result-block__sort-input only-mobile" }
const _hoisted_7 = { class: "none-Mobile" }
const _hoisted_8 = {
  key: 3,
  class: "result-block__cards"
}
const _hoisted_9 = {
  key: 4,
  id: "resultCards",
  class: "result-block__cards"
}
const _hoisted_10 = ["id"]
const _hoisted_11 = { key: 5 }

import { computed, inject, onMounted, Ref, ref, watch } from 'vue';
import { OptionType, ResultCardType, SortIdsType } from '@/types';
import ActiveCard from '@/components/Cards/SmallCards/OfferSmallCard/ActiveOfferCard/ActiveOfferCard.vue';
import { SmoothScrollOptions } from 'vue3-smooth-scroll';
import { LoadingOfferCard, OfferSmallCard } from '@/components/Cards';
import { useAppStore } from '@/store/modules/app';
import { useRouter } from 'vue-router';
import { useOfferCardsStore } from '@/store/modules/offerCards';
import { OpenSorting } from '@/components';


export default /*#__PURE__*/_defineComponent({
  __name: 'OfferCardsBlock',
  props: {
    isLoading: { type: Boolean },
    isMoreLoading: { type: Boolean },
    isTop: { type: Boolean },
    isMoreLink: { type: Boolean },
    title: { default: 'Подходящие вам' },
    resultCards: {},
    paginationPage: {},
    titleWithLine: { type: Boolean }
  },
  emits: ['sortResultBlock', 'changePageAndPageSize'],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const activeSort = computed((): string | undefined => {
  return useOfferCardsStore().activeSortId;
});
const emit = __emit;

const activeResultCardId: Ref<number | undefined> = ref(undefined);
const preparedResultCards = computed((): ResultCardType[] => {
  return props.resultCards;
});

const objectCount = computed(() => {
  return useOfferCardsStore().objectCount;
});
const activeBlockHeight: Ref<string> = ref('');

const sortOptions: OptionType[][] = [
  [
    { id: 'priceUp', name: 'По цене', icon: 'north' },
    { id: 'priceDown', name: 'По цене', icon: 'south' },
  ],
  [
    { id: 'houseAreaUp', name: 'По площади дома', icon: 'north' },
    { id: 'houseAreaDown', name: 'По площади дома', icon: 'south' },
  ],
  [
    { id: 'landAreaUp', name: 'По площади участка', icon: 'north' },
    { id: 'landAreaDown', name: 'По площади участка', icon: 'south' },
  ],
  [
    { id: 'popularityUp', name: 'По популярности', icon: 'north' },
    { id: 'popularityDown', name: 'По популярности', icon: 'south' },
  ],
];

const sortOfferCards = (id: SortIdsType) => {
  emit('sortResultBlock', id);
};

const smoothScroll = inject('smoothScroll') as (args: SmoothScrollOptions) => void;
const scrollToMyEl = (myEl: HTMLElement, updateHistory: boolean = true) => {
  smoothScroll({
    scrollTo: myEl,
    offset: -100,
    updateHistory: updateHistory,
  });
};

const router = useRouter();
const changeActive = (id: number) => {
  if (useAppStore().getWindowWidth() > 600 && !props.isMoreLink) {
    if (activeResultCardId.value === id) {
      activeResultCardId.value = undefined;
    } else {
      activeResultCardId.value = id;
      setTimeout(() => {
        const myEl = document.getElementById(`resultCard${id}`);

        if (myEl) {
          scrollToMyEl(myEl, false);
        }
      }, 200);
      useAppStore().sendStatistic(5);
    }

    updateActiveBlock();
  } else {
    router.push({ name: 'offerCard', params: { id: id } });
  }
};
const updateActiveBlock = () => {
  setTimeout(() => {
    const activeBlock = document.getElementById('activeCard');

    let height = activeBlock ? activeBlock!.clientHeight : 0;

    activeBlockHeight.value = height ? `${height + 420}px` : '100%';
  }, 1);
};

onMounted(() => {});
watch(
  () => props.isLoading,
  () => {
    updateActiveBlock();
  },
);

return (_ctx: any,_cache: any) => {
  const _component_base_skeleton_loader = _resolveComponent("base-skeleton-loader")!
  const _component_base_divider = _resolveComponent("base-divider")!
  const _component_base_select_input = _resolveComponent("base-select-input")!
  const _component_base_pagination_group = _resolveComponent("base-pagination-group")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.isLoading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createVNode(_component_base_skeleton_loader, {
              style: { height: '30px', width: '300px' },
              type: "mediumText"
            })
          ]))
        : (_openBlock(), _createElementBlock("div", {
            key: 1,
            class: _normalizeClass([{ 'result-block__title-with-line': _ctx.titleWithLine }, "result-block__title-box"])
          }, [
            (_ctx.titleWithLine)
              ? (_openBlock(), _createBlock(_component_base_divider, { key: 0 }))
              : _createCommentVNode("", true),
            _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.title), 1),
            (_ctx.titleWithLine)
              ? (_openBlock(), _createBlock(_component_base_divider, { key: 1 }))
              : _createCommentVNode("", true)
          ], 2)),
      (!_ctx.isTop)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createVNode(_component_base_select_input, {
                loading: _ctx.isLoading,
                modelValue: activeSort.value,
                options: sortOptions.flat(),
                label: "Сортировать по",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (sortOfferCards($event)))
              }, null, 8, ["loading", "modelValue", "options"])
            ]),
            _createElementVNode("div", _hoisted_7, [
              _createVNode(_unref(OpenSorting), {
                loading: _ctx.isLoading,
                modelValue: activeSort.value,
                "sort-options": sortOptions,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (sortOfferCards($event)))
              }, null, 8, ["loading", "modelValue"])
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.isLoading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.isTop ? 4 : 8, (i) => {
              return (_openBlock(), _createElementBlock("div", { key: i }, [
                _createVNode(_unref(LoadingOfferCard))
              ]))
            }), 128))
          ]))
        : (preparedResultCards.value.length)
          ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(preparedResultCards.value, (card) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: card.id,
                  style: _normalizeStyle([activeResultCardId.value === card.id ? { height: activeBlockHeight.value } : ''])
                }, [
                  _createVNode(_unref(OfferSmallCard), {
                    card: card,
                    "is-active": activeResultCardId.value === card.id,
                    onChangeActive: changeActive
                  }, null, 8, ["card", "is-active"]),
                  (activeResultCardId.value === card.id)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        id: 'resultCard' + String(card.id),
                        class: "result-block__cards-activeBlock"
                      }, [
                        _createVNode(ActiveCard, {
                          card: card,
                          onChangeActive: changeActive,
                          onUpdateActiveBlock: updateActiveBlock
                        }, null, 8, ["card"])
                      ], 8, _hoisted_10))
                    : _createCommentVNode("", true)
                ], 4))
              }), 128))
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_11, "По вашему запросу ничего не найдено")),
      (!_ctx.isTop && preparedResultCards.value.length)
        ? (_openBlock(), _createBlock(_component_base_pagination_group, {
            key: 6,
            customPage: _ctx.paginationPage,
            isLoading: _ctx.isLoading,
            isMoreLoading: _ctx.isMoreLoading,
            itemCountOnPage: 8,
            "max-for-visible": 40,
            "min-for-visible": 8,
            objectCount: objectCount.value,
            "step-for-visible": 8,
            value: preparedResultCards.value,
            values: _ctx.resultCards,
            "auto-add-mobile": "",
            class: "mt--30",
            onChangePageAndPageSize: _cache[2] || (_cache[2] = ($event: any) => (emit('changePageAndPageSize', $event)))
          }, null, 8, ["customPage", "isLoading", "isMoreLoading", "objectCount", "value", "values"]))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})